import Vue from "vue";
import Vuex from "vuex";
import { ls, getUrlParams } from "@js/utils";
import { fetchLang } from "@js/api/index";
import userInfo from "./modules/userInfo";
import petInfo from "./modules/petInfo";
import taskInfo from "./modules/taskInfo";
import guidance from "./modules/guidance";
import village from "./modules/village";
import postmateIframe from "./modules/postmateIframe";

Vue.use(Vuex);
function plugin(store) {
  store.subscribe((mutation, state) => {
    console.log(
      `%c mutation %c ${mutation.type}`,
      "background: #09f; padding: 2px; color: #fff;",
      "background: #099; padding: 2px; color: #fff;",
      mutation.payload
    );
    console.log(
      `%c state %O`,
      "background: #09f; padding: 2px; color: #fff;",
      state
    );
  });
}
export default new Vuex.Store({
  plugins: process.env.NODE_ENV !== "production" ? [plugin] : [],
  modules: {
    userInfo,
    petInfo,
    taskInfo,
    guidance,
    village,
    postmateIframe,
  },
  state: {
    path: [], // 记录路由
    direction: "forward", // 页面切换方向 forward|reverse
    lang: "",
    langTexts: {}, // 多语言内容
    dots: [], // 需要出现红点的容器列表
    publicBGM: ls.get("bg_sound"), // 背景音乐
    efSound: ls.get("ef_sound"), // 音效
    pageDisableEvent: false, // 页面是否接受点击事件
    pageSize: "",
  },
  mutations: {
    // 当前语言
    upDateLanguage(state, lang) {
      state.lang = lang;
    },
    // 当前语言的语言包
    upDateLangText(state, text) {
      state.langTexts = text;
    },
    // 路由历史顺序
    upDatePath(state, newPath) {
      state.path.push(newPath);
    },
    // 更新红点容器
    upDateDot(state, newDots) {
      state.dots = newDots;
    },
    upDateDirection(state, direction) {
      state.direction = direction;
    },
    // 更新是否播放音效
    upDateEfSound(state, status) {
      state.efSound = status;
    },
    // 更新是否播放背景音乐
    upDateBGM(state, status) {
      state.publicBGM = status;
    },
    // 更新全局接受点击事件
    upDatePageDisableEvent(state, status) {
      state.pageDisableEvent = status;
    },
    // 页面尺寸更新时触发
    upDatePageSize(state, status) {
      state.pageSize = status.width + "|" + status.height;
    },
  },
  actions: {
    upDateLanguage({ commit }, langs) {
      // 应用自动获取cookie的语言
      return "pl";
    },
    async upDateLangText({ commit }, lang) {
      try {
        if (_langs) {
          commit("upDateLangText", _langs);
        } else {
          let data = await fetchLang(lang);
          if (data.status == 200) {
            commit("upDateLangText", data.data);
          } else {
            toast(data.msg);
          }
        }
      } catch {
        let data = await fetchLang(lang);
        if (data.status == 200) {
          commit("upDateLangText", data.data);
        } else {
          toast(data.msg);
        }
      }
    },
    upDatePath({ commit }, path) {
      commit("upDatePath", path);
    },
    // 更新红点数据
    upDateDot({ commit, state }, params) {
      let tempDot = [...state.dots];
      if (!Array.isArray(params)) {
        // 如果不是数组则存入数组
        params = [params];
      }
      params.forEach(({ target, increase = true }) => {
        if (increase) {
          // 增加红点
          if (tempDot.some((i) => i.class == target.class)) {
            // 如果已经存在红点
            return;
          }
          tempDot.push(target);
        } else {
          // 删除红点
          let index = tempDot.findIndex((i) => i.class == target.class);
          if (index > -1) {
            tempDot.splice(index, 1);
          }
        }
      });
      commit("upDateDot", tempDot);
    },
    // 更新是否播放音效
    upDateEfSound({ commit }, status) {
      ls.set("ef_sound", status);
      commit("upDateEfSound", status);
    },
    // 更新是否播放背景音乐
    upDateBGM({ commit }, status) {
      ls.set("bg_sound", status);
      commit("upDateBGM", status);
    },
    upDatePageDisableEvent({ commit }, status) {
      commit("upDatePageDisableEvent", status);
    },
    upDatePageSize({ commit }, status) {
      console.log(status);
      commit("upDatePageSize", status);
    },
  },
});
